import "./SelectPage.scss";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import GreenBtnB from "../../Atoms/Buttons/RedBtnB";
import WhiteBtnB from "../../Atoms/Buttons/WhiteBtnB";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useEffect, useState } from "react";
import { sendCPLog } from "../../../Utils/Log/CPlog";
import Modal from "../../Atoms/Modals/Modal";
import { config } from "../../../config";
import CreditCard from "../../Atoms/Cards/CreditCard";
import Gpt300 from "../../Atoms/Course/Gpt_300";

const ResultTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 16px 119px;
  gap: 16px;

  width: 375px;
  height: 57px;
`;

const ResultTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 6px;

  width: 118px;
  height: 25px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 140%;

  text-align: center;
  color: #141617;
`;

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px 23px 50px;
  gap: 32px;

  background: #f6f9fa;
`;

const ResultText = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  text-align: center;

  color: #e8344e;
`;

const ResultContent = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;

  text-align: center;
  white-space: pre-wrap;
  align-items: flex-start;

  color: #141617;
`;

const NbSetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 24px;

  width: 314px;
  height: 302px;
`;

const NbSetTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;
`;

const NbBest = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 10px;

  height: 28px;

  background: #ffd0da;
  border-radius: 17px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 150%;

  text-align: center;
  color: #e8344e;
`;

const NbSetTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  /* identical to box height, or 28px */

  text-align: center;

  color: #141617;
`;

const NbCardWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
`;

const Header = styled.div``;

const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 16px;
`;

const NbOtherCourse = styled.div`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  /* identical to box height, or 24px */

  display: flex;
  align-items: center;
  text-align: center;

  /* Gray/Gray80 [day] */

  color: #5f666b;
`;

export default () => {
  const { state } = useLocation();
  let result = state?.result;
  const logObj = state?.logObj;
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(0);
  const toggleModal = () => {
    sendCPLog("nb_cardquiz_click_button", {
      button_text: "테스트 공유하기",
      result: "yes",
    });
    setModalVisible([1, 0][modalVisible]);
  };
  useEffect(() => {
    sendCPLog("nb_cardquiz_response", logObj);
  }, []);
  useEffect(() => {
    if (result === undefined) {
      navigate("/nb/selection");
    }
  }, []);

  useEffect(() => {
    if (modalVisible) {
      const timer = setTimeout(
        () => setModalVisible([1, 0][modalVisible]),
        2000
      );
      return () => clearTimeout(timer);
    }
  });
  return (
    <Wrapper>
      <Header>
        <ResultTitleWrap>
          <ResultTitle>대상자 조회결과</ResultTitle>
        </ResultTitleWrap>
      </Header>
      <ResultWrapper>
        <ResultText>축하합니다!</ResultText>
        <CreditCard />
        <ResultContent>
          {`인기 코딩강의 2개를 \n0원에 수강할 수 있어요!`}
        </ResultContent>

        <NbSetWrapper>
          <NbSetTitleWrap>
            <NbBest>BEST 국비지원 강의</NbBest>
            <NbSetTitle>ChatGPT 300% 활용하기</NbSetTitle>
          </NbSetTitleWrap>
          <NbCardWrap>
            <Gpt300 />
          </NbCardWrap>
        </NbSetWrapper>

        <NbOtherCourse>
          아래 버튼을 눌러 내일배움카드 발급 방법과
          <br />더 다양한 과목을 안내 받아 보세요
        </NbOtherCourse>

        <>
          <BtnContainer className="btn-container">
            <GreenBtnB
              onClick={() => {
                sendCPLog("nb_cardquiz_click_button", {
                  button_text: "국비지원 안내받기",
                  result: "yes",
                });
                window.open(`${config.scc.url}/nb/guide/`, "_blank");
              }}
            >
              국비지원 안내받기
            </GreenBtnB>
          </BtnContainer>
        </>
      </ResultWrapper>
      <Modal toggle={toggleModal} open={modalVisible}>
        <ResultModal>링크가 복사되었습니다.</ResultModal>
      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const ResultModal = styled.div`
  height: 100px;
  width: 320px;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.04px;
  text-align: center;
  color: #000;
`;
